import { render, staticRenderFns } from "./ModelViewVulkan.vue?vue&type=template&id=67f73b15&scoped=true"
import script from "./ModelViewVulkan.vue?vue&type=script&lang=js"
export * from "./ModelViewVulkan.vue?vue&type=script&lang=js"
import style0 from "./ModelViewVulkan.vue?vue&type=style&index=0&id=67f73b15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f73b15",
  null
  
)

export default component.exports